module.exports = __webpack_public_path__ + "32381880a11f0b064d44caa250a1579b.pdf";